<template>
  <div>
  
    <section  class="navbarsection" style="margin-top: -50px;">
          <div class="txtdata">
            <h1  style="padding-top: 200px;"></h1>
          </div>
            <div class="videosection" >
              <div  v-show="pvisvideo === true && pvpictureimage === false ">
                <Transition class="transition thing">
                  <video-background 
                    playbackRate=0.2
                    :src="src"
                    :poster="poster"
                    :class="`thing playercss`"
                    :style="`height: 600px;`">
                  </video-background>
                </Transition>
              </div>
            
                <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                </div>
      
                <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
       
          </div>
          <div class="overlay"></div>
          <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
            <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
          </div>
        </section>

  <section class="topsection">
    <div class="topdiv">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-9">
          <AllNewsdownload :allnewsdata="newsdata" @click="goToNextPage($event); goToPreviousPage($event);" 
        :showNextButton="showNextButton" :showPreviousButton="showPreviousButton" 
        />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3">
          <DateComponent :getyears="getyears" @submit="handleDateSubmit($event)" @click="getYear($event)"/>
        </div>
      </div>
    </div>
  </section>

  <section class="bottomtext">
    <div class=" bottomtext col-xs-12 col-sm-12">
      <hr />
      <p  v-html="auditbottompage">
      </p>
    </div>
  </section>


</div>
</template>

<script>

import DateComponent from '@/components/DateComponent.vue';
import AllNewsdownload from '@/components/AllNewsdownload.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/globalDeclare.js');
require('@/assets/css/video-js.css');
import axios from 'axios';
import moment from 'moment';


export default {
name: 'AboutView',
components: {
DateComponent, AllNewsdownload
},
data() {
return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  // pvwebm: '',
  // pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,
  pictureimage: '',

  breadcrumbsinfo: [],

  getyears: [],

  newsdata: [],
  showNextButton: false,
  showPreviousButton: false,
  currentPage: 1,
  query: '',

  height: 0,
  width: 0,
}
},
methods: {
  async goToNextPage($event) {
  let eAction = $event.target.value
  if (eAction === 'moveNext') {
    this.currentPage +=1,
    this.getNewsdata()
  }
 },
 async goToPreviousPage($event) {
  let pAction = $event.target.value
  if (pAction === 'movePrevious') {
    this.currentPage -=1,
    this.getNewsdata()
  }
 },

 async submitForm(event, inputVal) {
  if (event === 'submitform') {

  }
 },

 async getNewsdata() {
  this.$store.commit('SetIsLoading', true)

  this.showNextButton = false
  this.showPreviousButton = false
  //-----------Homepage News section-------------
  await axios.get(`homepagenewslisting/?page=${this.currentPage}`).then(
      response => {
          this.newsdata = response.data.results
          if(response.data.next) {
            this.showNextButton = true
          }
          if(response.data.previous) {
            this.showPreviousButton = true
          }
    })
    .catch((error) => {
        console.log(error)
      })
      // getmatchingnews
 },
 async handleDateSubmit($event) {
  // this.showNextButton = true
  // this.showPreviousButton = true
  let searchfact = $event.target[0].value
  let startdate = moment($event.target[1].value).format('YYYY-MM-DD')
  let enddate = moment($event.target[2].value).format('YYYY-MM-DD')
   
  await axios.get(`getmatchingnews/${searchfact}/${startdate}/${enddate}`).then(
    response => {
        this.newsdata = response.data
        if(response.data.length >= 10) {
          this.showNextButton = true
          this.showPreviousButton = true
        }
  })
  .catch((error) => {
      console.log(error)
    })
  },

  async getYear($event) {

    let yearVal = $event.target.value
    this.showNextButton = false
    this.showPreviousButton = false
   
  await axios.get(`getmatchingyearnews/${yearVal}?page=${this.currentPage}`).then(
    response => {
        this.newsdata = response.data
          if(response.data.length >= 10) {
          this.showNextButton = true
          this.showPreviousButton = true
        }
  })
  .catch((error) => {
      console.log(error)
    })

    
  }
},

async mounted() {
this.myPicUrl = myUrlPath
this.getNewsdata()

await axios.get('allpagespv/newsreleases').then(
    response => {
      this.videoimage = response.data

      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
  })
  .catch((error) => {
        console.log(error)
      })
  

//------------breadcrumbs mappings info---------------
await axios.get('getbreadcrumbsinfo/newsreleases').then(
response => {
    this.breadcrumbsinfo = response.data
  })
  .catch((error) => {
      console.log(error)
      })

 //------------YEARS---------------
 await axios.get('getallyears/').then(
    response => {
        this.getyears = response.data
  })
  .catch((error) => {
      console.log(error)
    })

  
}
}
</script>

<style scoped>

.container {
display: grid;
height: 100vh;;
grid-template-columns: 1fr;
grid-template-rows: .2fr 1.2fr .2fr;
grid-template-areas: 
"nav nav nav" 
"main main main" 
"footer footer footer";
grid-gap: 0.2rem;
font-family: "Inter", sans-serif;
font-size: 800;
font-size: 12px;
color: #234234;
text-align: center;
}

html { 
height: 100%;
margin:0px;
background: url('../assets/slide-5.jpg') no-repeat center center;
background-size: cover;
background-attachment: fixed;
}

main {
background: white;
grid-area: main;
padding-left: 0px;
padding-right: 0px;
margin-left: 0px;
margin-right: 0px;
border-radius: 0px;
margin-top:-5px;
}

.formatsections {
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 100px;
}

.breadcrumcss {
margin-top: 180px;
padding-left: 100px;
margin-bottom: -100px;
}
.bottomtext {
  text-align: justify;

  padding: 100px;
}
.videosection {
  margin-top: -10px;
}
.topsection {
  margin-top: 200px;
}
.videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .topdiv {
    padding-left: 40px;
    padding-right: 40px;
  }
 
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .topdiv {
    padding-left: 30px;
    padding-right: 30px;
  }
 

}


/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .topdiv {
    padding-left: 20px;
    padding-right: 20px;
  }
 

/*@-moz-document url-prefix() {
 
}*/
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

     .topdiv {
      padding-left: 100px;
      padding-right: 100px;
    }
 

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
 

} 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

} 


</style>
